<!--
    描述：角色管理页面
    时间：2020-04-20
    Created by ws
-->
<template>
    <div class="h100">
        <w-split v-model="splitValueL">
            <div class="h100" slot="left">
                <roleTreeTable ref="roleTreeTable" @row-click="roleRowClick"></roleTreeTable>
            </div>
          <div class="h100" slot="right">
            <el-col :span="11" class="h100" style="border-right:1px solid #eee">
              <menuTreeTable ref="menuTreeTable"  @row-click="menuRowClick"></menuTreeTable>
            </el-col>
            <el-col :span="13" class="h100" style="border-right:1px solid #eee">
              <btnTable ref="btnTable" @row-click="roleRowClick"></btnTable>
            </el-col>
          </div>
        </w-split>
    </div>
</template>

<script>
import roleTreeTable from './components/role_tree_table'
import menuTreeTable from './components/menu_tree_table'
import btnTable from './components/btn_table'
export default {
    components: {
        roleTreeTable,
        menuTreeTable,
        btnTable
    },
    data() {
        return {
            splitValueL: 0.3,
            splitValueR: 0.5,

            clickRoleObj : '',
            clickMenuObj : '',
        }
    },
    methods: {
        addClick(type){
            if(type==='addRole') this.$refs.roleTreeTable.doClick('','add')
        },
        roleRowClick(obj){
            this.clickRoleObj = obj
            //获取角色菜单信息
            this.$refs.menuTreeTable.getMenuTreeInfoByRoleId(obj);

            //获取角色菜单按钮信息
            this.clickMenuObj = ''
            let btnObj = {roleId : obj.id, menuId : ''}
            
            //查询按钮列表
            this.$refs.btnTable.initMenuBtnInfo(btnObj);

            //查询数据权限信息
            let dataObj = {roleId: obj.id, menuId : ''}
        },
        menuRowClick(e){
            this.clickMenuObj = e
            let obj = {menuId : e.id, roleId : ''}
            if(this.clickRoleObj != '') obj.roleId = this.clickRoleObj.id

            //查询按钮列表
            this.$refs.btnTable.initMenuBtnInfo(obj);
        },
    },
    // 进入缓存页面
    activated() {
        this.splitValueL = 0.3
        this.splitValueR = 0.5
    }
}
</script>

<style scoped lang="less">
.role-manage-main {
    height: 100%;
}
.w-page-main .w-page-header {
    position: relative;
    top: 0;
    left: 0;
    padding: 0 10px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    background-color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}
</style>
